exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-email {\n  width: 200px;\n}\n\n.list-actions div {\n  margin-right: 20px;\n}\n", ""]);

// exports
